import { ISeatInfo } from "./book.types";

export class SeatInfo implements ISeatInfo {
  bookedBySomeone: boolean;
  bookedByMe: boolean;
  floorNo: number;
  rowNo: number;
  columnNo: number;
  seatNo: string;

  constructor(data: ISeatInfo) {
    this.bookedBySomeone = data.bookedBySomeone;
    this.bookedByMe = data.bookedByMe;
    this.floorNo = data.floorNo;
    this.rowNo = data.rowNo;
    this.columnNo = data.columnNo;
    this.seatNo = data.seatNo;
  }
}
